// src/schemas/component-defaults.ts
import { Type } from "@sinclair/typebox";
import { HighchartsThemeDefaultsSchema } from "@json-to-office/shared";

// src/schemas/components/text.ts
import {
  TextPropsSchema,
  TextRunSchema
} from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/image.ts
import { PptxImagePropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/shape.ts
import {
  ShapePropsSchema,
  ShapeTypeSchema,
  TextSegmentSchema,
  GradientStopSchema,
  GradientFillSchema,
  PatternFillSchema,
  PATTERN_FILL_PRESETS
} from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/table.ts
import { PptxTablePropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/highcharts.ts
import { PptxHighchartsPropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/components/chart.ts
import { PptxChartPropsSchema } from "@json-to-office/shared/schemas/slide-content";

// src/schemas/component-defaults.ts
var TextComponentDefaultsSchema = Type.Partial(TextPropsSchema);
var ImageComponentDefaultsSchema = Type.Partial(PptxImagePropsSchema);
var ShapeComponentDefaultsSchema = Type.Partial(ShapePropsSchema);
var TableComponentDefaultsSchema = Type.Partial(PptxTablePropsSchema);
var HighchartsComponentDefaultsSchema = Type.Composite(
  [
    Type.Partial(Type.Omit(PptxHighchartsPropsSchema, ["options"])),
    HighchartsThemeDefaultsSchema
  ],
  {
    additionalProperties: false,
    description: "Highcharts defaults: slide placement and resources as partial props, and `options` written beneath every chart\u2019s own, as `Highcharts.setOptions` would."
  }
);
var ChartComponentDefaultsSchema = Type.Partial(PptxChartPropsSchema);
var PptxComponentDefaultsSchema = Type.Object(
  {
    text: Type.Optional(TextComponentDefaultsSchema),
    image: Type.Optional(ImageComponentDefaultsSchema),
    shape: Type.Optional(ShapeComponentDefaultsSchema),
    table: Type.Optional(TableComponentDefaultsSchema),
    highcharts: Type.Optional(HighchartsComponentDefaultsSchema),
    chart: Type.Optional(ChartComponentDefaultsSchema)
  },
  { additionalProperties: true }
);

export {
  TextPropsSchema,
  TextRunSchema,
  PptxImagePropsSchema,
  ShapePropsSchema,
  ShapeTypeSchema,
  TextSegmentSchema,
  GradientStopSchema,
  GradientFillSchema,
  PatternFillSchema,
  PATTERN_FILL_PRESETS,
  PptxTablePropsSchema,
  PptxHighchartsPropsSchema,
  PptxChartPropsSchema,
  TextComponentDefaultsSchema,
  ImageComponentDefaultsSchema,
  ShapeComponentDefaultsSchema,
  TableComponentDefaultsSchema,
  HighchartsComponentDefaultsSchema,
  ChartComponentDefaultsSchema,
  PptxComponentDefaultsSchema
};
//# sourceMappingURL=chunk-VLQAI2V6.js.map